//// product image gallery
(function($, window, undefined) {

  var defaults = {
    isSwiper:false,
    hasThumbs:true,
    onThumbClickCallback:false
  }

  function wbskGal(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.thumbs = this.element.find('.wbsk-gallery-thumbs')
    this.featImg = !this.settings.isSwiper ? this.element.find('.wbsk-gallery-feat-img') : false
    this.swiperContainer = this.settings.isSwiper ? this.element.find('.swiper-container') : false
    this.init()
  }

  wbskGal.prototype = {
    
    init: function() {      
      var _this = this
      this.thumbs = this.element.find('.wbsk-gallery-thumbs')
      if(this.settings.isSwiper && this.settings.items && this.settings.items.length > 0){
        this.initSwiper()
      }      
    },
    
    bindThumbs:function(){
      var _this = this;   
      this.thumbs.find('a').click(function(e){
        e.preventDefault()
        _this.thumbnail_handler($(this))
      })
    },
    
    //handler for thumbnail click
    thumbnail_handler:function($el){
      $el.addClass('active').siblings('a').removeClass('active') 
      
      if(this.settings.isSwiper && this.settings.items && this.settings.items.length > 0){
        this.swiper.slideTo($el.index())
      }
      
      if(!this.settings.isSwiper){
        this.updateFeaturedImgage()
      }
    
    },
    
    update_handler:function(sku){
      var _this = this
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      this.update_thumbs(sku).then(function(){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
        }
      })
    },
    
    //update the product thumbs
    update_thumbs:function(sku){
      var _this = this
      return new Promise(function(resolve,reject){
        //remove all thumbs
        _this.thumbs.empty()
        var thumbGroup = _this.settings.items.filter(function(slide){
          return slide.sku.includes(sku)
        })
        _this.thumbs.html(_this.getThumbs(thumbGroup[0]))
        _this.bindThumbs()
        if(_this.swiper){
          _this.update_slides(sku).then(function(){
            resolve()
          })
        }else{
          resolve()
        }
      })
    },
    
    getThumbs:function(thumbGroup){
      var thumbs = []
      thumbGroup.images.forEach(function(img,index){
        var active = ''
        if(index == 0){
           active = 'active'
        }
        var thumb = `<a href="${img.src}" class="d-block row--s ${active} @mobile-tablet__block-2/12 @mobile-tablet__cell-l--s @mobile-tablet__cell-r--s"><img class="lazyload" data-src="${img.src}" alt="${thumbGroup.sku}"></a>`
        thumbs.push(thumb)
      })
      return thumbs
    },
    
    
    //reg feat image update
    updateFeaturedImgage:function(){
      var src = this.thumbs.find('.active').prop('href')
      this.featImg.prop('src',src)
    },
    
    //swiper slide 
    initSwiper:function(){
      var _this = this
      //init swiper
      this.swiper = new Swiper(this.swiperContainer, {
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        //speed:0,
        spaceBetween:0,
        //effect:'fade',
        fadeEffect: {
          //crossFade: true
        },
        loazyLoad:true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount:4 ,
        },
        autoHeight: false,
        preloadImages: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },    
      })
      
      this.swiper.on('slideChange',function(){
        _this.updateThumbsFromSlider()
        if(window.wbsk_customizer && wbsk_customizer.is_init){
          var canvas = $('.js-cstmzr__canvas-wrapper')
          if(this.activeIndex == 0){
            canvas.show()
          }else{
            canvas.hide()
          }
        }
      })
      
    },
    
    getSlides:function(sliderGroup){
     
      var slides = []
      sliderGroup.images.forEach(function(img){
        var slide = `<li class="swiper-slide" data-sku="${sliderGroup.sku}">
                     <div class="far-image far-image--square">
                     ${!img.video ? `
                     <img data-src="${img.src}" class="lazyload">
                     ` : `
                     <video  loop autoplay muted playsinline poster="${img.src}" 
                             class="block-12/12">
                             <source src="${img.video}" type="video/mp4">
                             Your browser does not support the video tag.
                     </video>
                     `}
                     </div>
                     </li>`
        slides.push(slide)
      })
      return slides
    },
    
    update_slides:function(sku){
      var _this = this
      return new Promise(function(resolve,reject){
        //remove all slides
        var sliderGroup = _this.settings.items.filter(function(slide){
          return slide.sku.includes(sku)
        })
        _this.swiper.removeAllSlides();
        _this.swiper.appendSlide(_this.getSlides(sliderGroup[0]))
        _this.swiper.update()
        _this.swiper.slideTo(0)
        resolve()
      })
    },
    
    updateThumbsFromSlider:function(){
      var slideIndex = this.swiper.activeIndex
      this.thumbs.find('a').removeClass('active').eq(slideIndex).addClass('active')
    },
        
  }

  $.fn.wbskGal = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskGal', new wbskGal(this, settings))
    })
  }

}(jQuery, window));